import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=610fe51c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=610fe51c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610fe51c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('610fe51c')) {
      api.createRecord('610fe51c', component.options)
    } else {
      api.reload('610fe51c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=610fe51c&scoped=true&", function () {
      api.rerender('610fe51c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fc7LMPXp1UAd/JS/comp/GuestBox.vue"
export default component.exports